import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from 'react-router-dom';
import LoginPage from './LoginPage';
import AddPhoneForm from './AddPhoneForm';
import ProtectedRoute from './ProtectedRoute';
import Statistics from './Statistics';
import BotContentManager from './BotContentManager';
import Broadcast from './Broadcast';
import './styles/navbar.css';
import Settings from './Settings';

function Navbar({ onLogout }) {
  return (
    <nav className="navbar">
      <div className="navbar-logo">📱 NTS Admin</div>
      <ul className="navbar-links">
        <li><Link to="/statistics">Статистика</Link></li>
        <li><Link to="/add-phone">Добавить телефон</Link></li>
        <li><Link to="/bot">Контент Бота</Link></li>
        <li><Link to="/broadcast">Рассылка</Link></li>
        <li><Link to="/settings">Настройки</Link></li>


        <li><button onClick={onLogout} className="logout-button">Выйти</button></li>
      </ul>
    </nav>
  );
}

function AppWrapper() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token'); // remove JWT token
    navigate('/login');               // redirect to login
  };

  return (
    <>
      <Navbar onLogout={handleLogout} />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/settings" element={<Settings />} />
        <Route
          path="/add-phone"
          element={
            <ProtectedRoute>
              <AddPhoneForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/statistics"
          element={
            <ProtectedRoute>
              <Statistics />
            </ProtectedRoute>
          }
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AddPhoneForm />
            </ProtectedRoute>
          }
        />
        <Route path="/bot"
          element={
            <ProtectedRoute>
              <BotContentManager />
            </ProtectedRoute>
          } />
        <Route path="/broadcast"
          element={
            <ProtectedRoute>
              <Broadcast />
            </ProtectedRoute>
          } />
      </Routes>
      <footer className="footer">
        <p>&copy; 2025 Надежные Смартфоны. All rights reserved.</p>
      </footer>
    </>
  );
}

// Required so useNavigate works at the top level
function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;
